
// import api from '@/request/api';
import Vue from "vue";
export default {
    namespaced: true,
    state: {
        userInfo: {},
        returnSup:'',
        fastHeader:[
            //顶部快捷按钮区
            {
                name: '到期域名',
                item: {
                    oparg:'domain-list',
                    title: '域名列表'
                },
                num: '0', //红色数字
                isShow: false, //是否有对应的菜单权限，有-显示，默认false不显示
            },
            {
                name: 'NS修改失败',
                item: {
                    oparg:'domain-list',
                    title: '域名列表'
                },
                num: '0',
                isShow: false,
            },
        ],
        DomainCount:0,
        NotExpiredCount:0
    },
    mutations: {
        updateFastHeader(state, { expiredCount, failedNsCount,DomainCount,NotExpiredCount }){
			state.fastHeader[0].num = expiredCount
            state.fastHeader[1].num = failedNsCount
            state.DomainCount = DomainCount
            state.NotExpiredCount = NotExpiredCount
		},
        changeFastheaderShow(state,{ index, flag }){
            state.fastHeader[index].isShow = flag 
        },
    },
    actions: {
        fetchHeaderExpireMsg({ commit }){

            let dataObj={ops:'CntDomainStatus',params:{}}
            
            Vue.prototype.$api.dns.domain(dataObj).then(res => {
                commit('updateFastHeader', {
                    expiredCount: res.data.cntExpired,
                    failedNsCount: res.data.cntFailedNs,
                    DomainCount:res.data.cntDomain,
                    NotExpiredCount:res.data.cntNotExpired
                })
            })
        },
    },
    getters: {
        userInfo: state => {
            return state.userInfo;
        },
    },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/User.js